<div class="payment-details-card">
    <div class="pt-0 mb-3">
        <div class="payment-details-panel">
            <div class="payment-header my-3">
                <div class="header-content">
                    <div class="left-section">
                        <div class="mat-subtitle-1 m-0">Transactions in cart:</div>
                        <div class="mat-caption">{{ paymentRequests.length }} transactions</div>
                    </div>

                    <button
                        type="submit"
                        class="delete-button mat-subtitle-2"
                        color="primary"
                        mat-button
                        (click)="deleteCart()"
                        id="delete-all-items"
                    >
                        @if (!deletingCart) {
                            <span>Delete all</span>
                        }
                        @if (deletingCart) {
                            <mat-icon class="spinner-icon" color="error">
                                <mat-spinner diameter="20" color="error" />
                            </mat-icon>
                        }
                    </button>
                </div>
            </div>
            @if (financeDisclaimer) {
                <div class="mb-3">
                    <app-disclaimer-bar [textInput]="financeDisclaimer"></app-disclaimer-bar>
                </div>
            }
            <div class="payment-content py-0">
                @if (cartSplitByAwbAndFlight) {
                    @for (awb of awbs; let awbIndex = $index; let last = $last; let first = $first; track awbIndex) {
                        <div class="payment-item h-auto p-0 overflow-visible" [ngClass]="{ 'mt-3': !first }">
                            <app-payment-awb-by-flight [awb]="awb" [first]="first" [aboveThreshold]="aboveThreshold" />
                        </div>
                    }
                } @else {
                    @for (
                        payment of paymentRequests;
                        let paymentIndex = $index;
                        let last = $last;
                        let first = $first;
                        track paymentIndex
                    ) {
                        <div class="payment-item h-auto p-0 overflow-visible" [ngClass]="{ 'mt-3': !first }">
                            <app-cart-payment-details-card
                                [paymentRequest]="payment"
                                [first]="first"
                                (removePaymentById)="removePayment($event)"
                                (editPayment)="editPaymentRequest($event)"
                            />
                        </div>
                    }
                }
            </div>
        </div>
    </div>
</div>
